<template>
  <el-row type="flex" justify="space-between">
    <click-to-edit
      v-model="scope.row.name"
      :placeholder="$companyConfiguration.i18n.t('card', 'section_element_name_column_placeholder')"
      :disabled="!isFieldAvailableForEdit(scope.row, 'name')"
      style="width: 100%"
      type="textarea"
      :word-limit="$companyConfiguration.settings.getElementsNameMaxLength()===false ? 0 :$companyConfiguration.settings.getElementsNameMaxLength()"
      :show-word-limit="!!$companyConfiguration.settings.getElementsNameMaxLength()"
      show-word-limit
      @input="saveElementPropChange(scope.row, 'name')"
    ></click-to-edit>
    <click-to-edit
      v-model="scope.row.desc"
      :placeholder="isFieldAvailableForEdit(scope.row, 'desc')
        ? $companyConfiguration.i18n.t('card', 'section_element_desc_column_placeholder')
        : 'Описание не добавлено'"
      :disabled="!isFieldAvailableForEdit(scope.row, 'desc')"
      type="button-modal"
      modal-title="Описание"
      @input="saveElementPropChange(scope.row, 'desc')"
    >
      <el-button
        slot="reference"
        class="table-action-button open-desc-button"
        :class="{'has-desc': !!scope.row.desc}"
        type="text"
        round
        size="mini"
        icon="fas fa-info-circle"
      ></el-button>
    </click-to-edit>
    <el-popover
      v-if="scope.row.cascading_element_id"
      placement="left"
      trigger="hover"
    >
      <div>
        Руководитель каскадировал эту цель
      </div>
      <el-button
        slot="reference"
        style="padding: 5px; margin-left: 5px"
        type="default"
        round
        size="mini"
        icon="fas fa-share-alt"
      >
      </el-button>
    </el-popover>
  </el-row>
</template>

<script>
import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";

export default {
  name: 'cherkizovo-element-name-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>

<style scoped lang="scss">
@import "./src/assets/css/project-variables";

.open-desc-button {
  color: gray;

  &.has-desc{
    color: $--color-primary;
  }
}
</style>
